<template>
  <div
    v-if="
      extras.groupDownloadDisplay && extras.groupDownloadDisplay.display == 1
    "
    :style="{
      background:
        extras.downloadBg.colorOrBg == 'color'
          ? extras.downloadBg.color
          : 'url(' + extras.downloadBg.src + ')',
    }"
    class="m-load top-nav m-journalism new"
    id="download"
  >
    <WapTitle
      v-if="extras.downloadTitle.display == 1"
      :title="extras.downloadTitle.mainTitle || title"
      :en="extras.downloadTitle.subTitle || 'DOWNLOAD'"
      :extras="extras"
    />

    <div
      class="m-tab-list-new-wap"
      v-if="folderList.length > 1"
      :class="'tab-length' + folderList.length"
    >
      <div
        class="tab-new"
        v-for="(item, index) in folderList"
        :key="index"
        :class="{
          active: item.id == currentId,
        }"
        @click="columnClick(item)"
      >
        {{ item.name }}
        <div data-v-2a8f24dd="" class="underline"></div>
      </div>
    </div>

    <div
      class="g-download-list-new-wap"
      :class="extras.downloadStyle.style == '1' ? 'single' : ''"
      v-if="fileList && fileList.length > 0"
    >
      <div
        class="item"
        v-for="(item, index) in fileList"
        :key="index"
        :style="{
          background:
            extras.downloadItemBg.colorOrBg == 'color'
              ? extras.downloadItemBg.color
              : 'url(' + extras.downloadItemBg.src + ')',
        }"
      >
        <img
          :src="
            item.iconMapRealPath
              ? item.iconMapRealPath
              : require('@/assets/images/defaultNew.jpg')
          "
          @click="see(item)"
          alt=""
        />
        <div
          class="name"
          @click="see(item)"
          v-if="extras.downloadItenTitle.display == 1"
          :style="{
            color:
              extras.downloadItenTitle.text == 'custom'
                ? extras.downloadItenTitle.fontColor
                : '',

            'font-style':
              extras.downloadItenTitle.text == 'custom'
                ? extras.downloadItenTitle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras.downloadItenTitle.text == 'custom'
                ? extras.downloadItenTitle.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          }"
        >
          {{ item.name }}
        </div>
        <div
          class="button"
          v-if="extras.downloadButton.display == 1"
          @click="download(item)"
          :style="{
            //                   'width':extras.downloadButton.layout == 'custom'?extras.downloadButton.btnWidth+'%':'',
            background:
              extras.downloadButton.layout == 'custom'
                ? extras.downloadButton.colorOrBg == 'color'
                  ? extras.downloadButton.color
                  : 'url(' + extras.downloadButton.src + ')'
                : '',
            color:
              extras.downloadButton.style == 'custom'
                ? extras.downloadButton.fontColor
                : '',

            'font-style':
              extras.downloadButton.style == 'custom'
                ? extras.downloadButton.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras.downloadButton.style == 'custom'
                ? extras.downloadButton.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
            'border-width': extras.downloadButton.border == 'show' ? '' : 0,
          }"
        >
          <span
            class="icontemp download-a"
            v-if="extras.downloadButtonText.icon != 'hide'"
          ></span>
          {{ extras.downloadButtonText.text }}
        </div>
      </div>
    </div>
    <div class="no-data" v-if="fileList && fileList.length == 0">
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">{{ $t("暂无数据") }}</div>
    </div>

    <vodal :show="show" animation="zoom" @hide="show = false">
      <div class="mail-box" v-if="Sent">
        <div class="title">请输入您的邮箱</div>
        <div class="mail" style="height: 7vw">
          <input type="text" placeholder="请输入您的邮箱" v-model="mailbox" />
          <span>{{ tip }}</span>
        </div>
        <div class="btn" @click="determine()">确定</div>
      </div>
      <div class="success" v-else>
        <p>已下载成功</p>
        <div>请稍后查看您的邮箱</div>
      </div>
    </vodal>
  </div>
</template>

<script>
import WapTitle from "./Title.vue";
import { interact, URLS } from "fire-wind-water/index";
import Api from "@/service/api";
import { tMixin } from "../../utils/i18n-t";

export default {
  components: {
    WapTitle,
  },
  mixins: [tMixin],
  props: {
    fileInfo: Object,
    extras: Object,
    seminarInfo: Object(),
  },
  data() {
    return {
      listArr: [],
      show: false,
      Sent: true,
      imgList: [
        {
          img: require("@/assets/images/wap/icon/pdf.png"),
          type: "pdf",
        },
        {
          img: require("@/assets/images/wap/icon/audio.png"),
          type: "audio",
        },
        {
          img: require("@/assets/images/wap/icon/docx.png"),
          type: "docx",
        },
        {
          img: require("@/assets/images/wap/icon/flv.png"),
          type: "flv",
        },
        {
          img: require("@/assets/images/wap/icon/img.png"),
          type: "img",
        },
        {
          img: require("@/assets/images/wap/icon/ppt.png"),
          type: "ppt",
        },
        {
          img: require("@/assets/images/wap/icon/txt.png"),
          type: "txt",
        },
        {
          img: require("@/assets/images/wap/icon/video.png"),
          type: "video",
        },
        {
          img: require("@/assets/images/wap/icon/xlsx.png"),
          type: "xlsx",
        },
        {
          img: require("@/assets/images/wap/icon/zip.png"),
          type: "zip",
        },
      ],
      tip: "",
      mailbox: "", // 邮箱
      title: "资料下载",
      icon: require("@/assets/images/wap/xiazai.png"),
      fileList: [],
      folderList: [],
      currentId: 0,
      isShowMore: false,
      defaultColor: "#ffffff",
    };
  },
  mounted() {
    //this.initColumns();
    let tempColumns = this.getColumns.fileInitColumns(
      this.fileInfo.folderList,
      this.fileInfo.fileList,
      "大会资料"
    );
    this.folderList = tempColumns;
    this.fileList =
      this.folderList.length == 0 ? [] : this.folderList[0].fileList;
    this.currentId = this.folderList.length == 0 ? 0 : this.folderList[0].id;
  },
  methods: {
    initColumns() {
      let tempArticles = this.fileInfo.fileList;
      let tempColumns = this.fileInfo.folderList;
      const columns = [
        {
          id: 0,
          name: "大会资料",
          fileList: tempArticles,
        },
      ];
      for (let i in tempColumns) {
        columns.push(tempColumns[i]);
      }
      this.folderList = columns;
      this.fileList = this.folderList[0].fileList;
      this.currentId = this.folderList[0].id;
    },
    columnClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = item.id;
      console.log("item", item);
      this.fileList = item.fileList;
    },
    DayClick(i) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = i;
    },
    determine() {
      var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(this.mailbox)) {
        this.tip = "请输入正确邮箱";
      } else {
        var vm = this;
        vm.downloadEvent(this.mailbox, this.listArr);
      }
    },
    handlePreview(previewUrl) {
      const url = window.location.href;
      let previewCode = "11291";
      switch (url) {
        case url.indexOf("://dev") >= 0:
          previewCode = "11291";
          break;
        case url.indexOf("://tf") >= 0:
          previewCode = "18077";
          break;
        case url.indexOf("://uf") >= 0:
        case url.indexOf("://uat") >= 0:
          previewCode = "14461";
          break;
        default:
          previewCode = "14460";
          break;
      }
      const protocolMatch = previewUrl.indexOf("https");
      let resultUrl = `http://ow365.cn/?i=${previewCode}&furl=${previewUrl}&type=download`;
      if (protocolMatch === 0) {
        resultUrl = `http://ow365.cn/?i=${previewCode}&ssl=1&furl=${previewUrl}&type=download`;
      }
      return resultUrl;
    },
    see(file) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (file.type === "mp4") {
        window.$sk.goto(file.wapUrl, true).subscribe((url) => {
          window.open(url);
        });
      } else {
        const previewUrl = this.handlePreview(file.preview);
        window.$sk.goto(previewUrl, true).subscribe((url) => {
          window.open(url);
        });
      }

      const { tenantId, weChatId } = this.seminarInfo;
      const userInfo = this.userInfo;
      Api.previewFile({
        browseInfo: interact.browseInfo,
        currentUrl: file.preview,
        fileId: file.id,
        globalUserId: userInfo.globalUserId,
        sess: userInfo.session,
        tenantId,
        weChatId,
        source: "WAP",
      });
    },
    getForm(formId) {
      const param = {
        tenantId: this.seminarInfo.tenantId,
        memberFormId: formId,
        schemaId: this.seminarInfo.schemaId,
        formId: formId,
      };
      return Api.getFormNewRegister(param);
    },
    download(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      var arr = [];
      if (item.identity == 3 && item.registerFormId) {
        //需要登录
        const info = window.$sk.template.get();
        const smarketMember = info.cookie.getSession();
        this.isLogin = !!smarketMember;
        if (this.isLogin) {
          this.path = item.previewRealPath;

          arr.push(item.id);
          // this.fileList = arr;
          this.listArr = [item.id];
          this.show = true;
          this.Sent = true;
          this.tip = "";
        } else {
          this.getForm(item.registerFormId).then((res) => {
            if (res.result == 0) {
              const loginUrl = URLS.updateSearchParam(
                "backUrl",
                encodeURIComponent(window.location.href),
                res.content.originUrl.wap
              );
              window.$sk.goto(loginUrl);
            }
          });
        }
      } else {
        this.path = item.previewRealPath;
        arr.push(item.id);
        // this.fileList = arr;
        this.listArr = [item.id];
        this.show = true;
        this.Sent = true;
        this.tip = "";
      }
    },
    downloadEvent(mailbox, fileList) {
      const instanceId = URLS.getURL("instanceId");
      const info = window.$sk.template.get();
      const { globalUserId } = info.user;
      Api.getDownloadWithEmail({
        instanceId,
        email: mailbox,
        globalUserId,
        moduleType: 3,
        fileList,
      }).subscribe((item) => {
        console.log("item", item);
        this.tip = item ? item.desc : "";
        this.Sent = false;
      });
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>
<style scoped></style>
